import { AGES } from './constants';
import { getAge } from '../../../Helpers/dates';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

/**
 * Checks which age range an age falls into
 * @param {number} age - The age to check
 * @returns {string|null} The matching age range or null if not found
 */
export const getAgeRange = (age) => {
  for (const ageRange of AGES) {
    // Handle "Over X" format
    if (ageRange.toLowerCase().startsWith('over')) {
      const minAge = parseInt(ageRange.match(/\d+/)?.[0] || '0');
      if (age > minAge) return ageRange;
      continue;
    }

    // Handle "X-Y" format
    const rangeParts = ageRange.split('-');
    if (rangeParts.length === 2) {
      const minAge = parseInt(rangeParts[0]);
      const maxAge = parseInt(rangeParts[1]);
      if (age >= minAge && age <= maxAge) return ageRange;
    }
  }

  return null; // Age doesn't match any range
};

export default (data) => {
  if (!data) return {};
  const mappedData = { ...data };
  const contact = mappedData?.contacts?.find(
    ({ contactTypeId }) => contactTypeId === 1
  );
  const primaryAddress = contact?.contactAddresses?.find(
    ({ addressTypeId }) => addressTypeId === 1
  );
  const age = getAge(new Date(mappedData?.birthDate));
  return {
    customerName: mappedData?.firstName,
    customerSurname: mappedData?.lastName,
    fiscalCode: mappedData?.fiscalCode,
    gender: mappedData?.gender,
    deutscheBankCustomer: true,
    city: primaryAddress?.city,
    zipCode: primaryAddress?.zipCode,
    province: primaryAddress?.state,
    occupation: capitalize(contact?.occupation),
    company: mappedData?.employeer,
    age: age ? getAgeRange(age) : null,
  };
};
